import { Component, ViewChild, AfterViewInit, Input, OnInit, ElementRef, OnDestroy, Inject, ChangeDetectionStrategy, ChangeDetectorRef, DoCheck } from '@angular/core';
import { NotificationCenterComponent } from '../notification-center/notification-center.component'
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { CustomIconService } from '../../../core/services/custom-icon.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-notifications-button',
  templateUrl: './notifications-button.component.html',
  styleUrl: './notifications-button.component.scss'
})
export class NotificationsButtonComponent implements OnInit {
  model: any = {}
  badgeActive: boolean = false;
  private intervalId: any;

  constructor(
    private cdr: ChangeDetectorRef,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private customIconService: CustomIconService
  ) {
  }

  ngOnInit() {
    this.model = {
      partner: '',
      account: '',
      merchant: ''
    };

    this.model.open = true;
    this.customIconService.init();
    this.cdr.detectChanges();
    this.checkBadgeStatus();
    this.startAutoUpdate();

    this.route.paramMap.subscribe(params => {
      this.model.partner = params.get('partner') || undefined;
      this.model.account = params.get('account') || undefined;
      this.model.merchant = params.get('merchant') || undefined;
    });

  }

  ngOnDestroy(): void {
    clearInterval(this.intervalId);
  }

  checkBadgeStatus() {
    const notifications = JSON.parse(localStorage.getItem('notifications')) || [];

    this.badgeActive = notifications.some((notification: any) => notification.read === false && !notification.hidden);
  }

  startAutoUpdate() {
    this.intervalId = setInterval(() => {
      this.checkBadgeStatus();
    // }, 500000);
    }, 5000);
  }

  openNotificationCenter() {
    this.startAutoUpdate();
    this.dialog.open(NotificationCenterComponent, {
      maxWidth: '700px',
      width: '100%',
      autoFocus: false,
      data: {
        partner: this.model.partner,
        account: this.model.account,
        merchant: this.model.merchant,
      },
    });
  }
}

